import { starNFT } from '@jdiyield/abi'
import { NFTResult } from '@jdiyield/interfaces'
import { api } from '@jdiyield/utils'
import { print } from 'graphql'
import gql from 'graphql-tag'
import Web3 from 'web3'

import { makeBatchRequest } from '../utils'

export const getGalaxyNFTold = async (web3: Web3, account: string, contractAddress: string): Promise<NFTResult[]> => {
  try {
    const contract = new web3.eth.Contract(starNFT as any, contractAddress)
    const length = await contract.methods.starNFTCount().call()
    const balances = await makeBatchRequest(
      web3,
      [...new Array(+length)].map((_, id) => contract.methods.balanceOf(account, id).call)
    )
    const myTokenIds = balances.map((balance, id) => (balance !== '0' ? id : null)).filter((id) => !!id)
    console.log('myTokenIds', myTokenIds)
    return await Promise.all(
      myTokenIds.map(async (tokenID) => {
        const { data } = await api.get(`https://graphigo.prd.galaxy.eco/metadata/${contractAddress}/${tokenID}.json`)
        return {
          tokenID,
          thumbnail_url: data?.image,
          asset_url: data?.image,
          name: data?.name,
          asset_type: 'image',
          link: data?.external_link
        } as NFTResult
      })
    )
  } catch (error) {
    console.log(error)
    return []
  }
}

export async function getGalaxyNFT(account: string): Promise<NFTResult[]> {
  try {
    const { data } = await api.post(`https://cors-anywhere.herokuapp.com/https://graphigo.prd.galaxy.eco/query`, {
      operationName: null,
      variables: {
        address: account,
        option: {
          first: 100,
          order: 'DESC',
          orderBy: 'CreateTime'
        }
      },
      query: print(gql`
        query MyNFTs($address: String!, $option: ListNFTInput!) {
          addressInfo(address: $address) {
            nfts(option: $option) {
              totalCount
              pageInfo {
                endCursor
              }
              list {
                id
                name
                image
                powah
                category
                treasureBack
                nftCore {
                  id
                  name
                  symbol
                  contractAddress
                  dao {
                    id
                    name
                    logo
                    alias
                  }
                }
              }
            }
          }
        }
      `)
    })
    const result = data?.data?.addressInfo?.nfts?.list?.map(
      ({ id, image, name }) =>
        ({
          name: name ?? '',
          tokenID: id,
          asset_url: image,
          thumbnail_url: image,
          link: `https://galaxy.eco/alpacafinance`
        } as NFTResult)
    )
    return result
  } catch (error) {
    console.log(error)
    return []
  }
}
